// extracted by mini-css-extract-plugin
export default {"root":"FieldSelectableGroup_root__5Cwag","itemsRoot":"FieldSelectableGroup_itemsRoot__BN6uN","labelWrapper":"FieldSelectableGroup_labelWrapper__H+6ko"};